import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { enableAnalytics } from "./lib/firebase";

const consent = localStorage.getItem("consent");
if (consent === "granted") {
  enableAnalytics(); // only after user agrees
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
